import { render, staticRenderFns } from "./SamDataTable.vue?vue&type=template&id=f0ee86e2&scoped=true&"
import script from "./SamDataTable.vue?vue&type=script&lang=js&"
export * from "./SamDataTable.vue?vue&type=script&lang=js&"
import style0 from "./SamDataTable.vue?vue&type=style&index=0&id=f0ee86e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ee86e2",
  null
  
)

export default component.exports